export const ROUTES = {
  ROOT: '/',
  CONTRACTS: '/contracts',
  DETAIL: '/contracts/:id',
  DDJJ: process.env.REACT_APP_DDJJ_URL,
};
